import { createFileRoute } from '@tanstack/react-router';
import ReportingExportsPage from '@features/admin/orders/ReportingExportsPage';

export const Route = createFileRoute('/admin/reporting-exports/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ReportingExportsPage />;
}
